/* Layout types and other constants */
export const LAYOUT_VERTICAL = 'vertical';
export const LAYOUT_HORIZONTAL = 'horizontal';
export const LAYOUT_DETACHED = 'detached';
export const LAYOUT_TWO_COLUMN_MENU = 'two-column';

export const LAYOUT_WIDTH_FLUID = 'fluid';
export const LAYOUT_WIDTH_BOXED = 'boxed';

export const MENU_POSITION_FIXED = 'fixed';
export const MENU_POSITION_SCROLLABLE = 'scrollable';

export const LEFT_SIDEBAR_THEME_LIGHT = 'light';
export const LEFT_SIDEBAR_THEME_DARK = 'dark';
export const LEFT_SIDEBAR_THEME_BRAND = 'brand';
export const LEFT_SIDEBAR_THEME_GRADIENT = 'gradient';

export const LEFT_SIDEBAR_TYPE_DEFAULT = 'default';
export const LEFT_SIDEBAR_TYPE_CONDENSED = 'condensed';
export const LEFT_SIDEBAR_TYPE_COMPACT = 'compact';

export const TOPBAR_THEME_LIGHT = 'light';
export const TOPBAR_THEME_DARK = 'dark';
